
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeUnknownOutlined as ObiVesselTypeUnknownOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-unknown-outlined.js';
 
 
 

 
 export const ObiVesselTypeUnknownOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-type-unknown-outlined',
   elementClass: ObiVesselTypeUnknownOutlinedElement,
   events: {
     
   }
  });
 
 